import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { Asset, RenameAsset } from '../../context-discovery-services/models';

@Component({
    selector: 'adminapp-rename-asset',
    templateUrl: './rename-asset.component.html',
    styleUrls: ['./rename-asset.component.scss']
})
export class RenameAssetComponent implements AfterViewInit {

    selectedAssetIri: string;
    selectedAssetName: string;

    @ViewChild('renameAssetDialog') renameAssetDialog: any;
    @ViewChild('assetNameInput') assetRenameInput: any;
    @ViewChild('renameAssetButton') renameAssetButton: any;

    @Input()
    assetsList: Array<Asset>;


    @Output()
    assetRenamedSuccessEmitter: EventEmitter<RenameAsset> = new EventEmitter<RenameAsset>();

    ngAfterViewInit(): void {
        this.assetRenameInput.nativeElement.addEventListener('value-changed', this.validateAssetName.bind(this));
        this.renameAssetButton.nativeElement.addEventListener('click', this.emitRenameAssetEvent.bind(this));
    }

    open(assetIri: string, assetName: string) {
        this.selectedAssetIri = assetIri;
        this.selectedAssetName = assetName;
        this.renameAssetDialog.nativeElement.open();
        this.assetRenameInput.nativeElement.value = assetName;
    }

    validateAssetName(event) {

        if (/\s/g.test(event.detail.value)) {
            this.assetRenameInput.nativeElement.setAttribute('error-message',
                'Please enter a correct asset name. No spaces allowed.');

            this.setAttributesOfInputNativeElement(true);
            return;
        } else if (event.detail.value.length < 3 || event.detail.value.length > 25) {
            this.assetRenameInput.nativeElement.setAttribute('error-message',
                'Asset name should contain at least 3 characters and not more than 25 characters.');

            this.setAttributesOfInputNativeElement(true);
            return;
        } else {

            if (this.selectedAssetName !== event.detail.value && this.assetsList) {
                if (this.assetsList.filter(asset => {
                    return asset.label === event.detail.value;
                }).length === 1) {
                    this.assetRenameInput.nativeElement.setAttribute('error-message',
                        'An asset having this name already exists. Please type a new name.');

                    this.setAttributesOfInputNativeElement(true);
                    return;
                }
            }
        }

        this.setAttributesOfInputNativeElement(false);
    }

    private setAttributesOfInputNativeElement(setForInvalid: boolean) {
        if (setForInvalid) {
            this.assetRenameInput.nativeElement.setAttribute('invalid', '');
        } else {
            this.assetRenameInput.nativeElement.removeAttribute('error-message');
            this.assetRenameInput.nativeElement.removeAttribute('invalid');
        }
    }

    emitRenameAssetEvent() {
        this.assetRenamedSuccessEmitter.emit({
            assetIri: this.selectedAssetIri,
            assetName: this.assetRenameInput.nativeElement.value
        });
    }
}
